import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { withProps, compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import { PROMOTION_LIGHT_BOX_FORM, PROMOTION_REBATE_FIELD_NAME, PROMOTION_TIRE_FIELD_NAME } from './constants'
import { formSelector, getPromotions } from './selectors'
import { getMainInRebatesPrice, getTotalSavingsPrice } from './helpers'
import createViewModel from './createViewModel'
import BOTPromotionLightbox from './BOTPromotionLightbox'

const mapStateToProps = state => {
  const { activePromotions, availablePromotions } = getPromotions(state)

  const selectedRebatePromotionsId = formSelector(state, PROMOTION_REBATE_FIELD_NAME) || []
  const selectedTirePromotionsId = formSelector(state, PROMOTION_TIRE_FIELD_NAME) || ''

  const totalAfterSavingsPrice = getTotalSavingsPrice({ selectedTirePromotionsId, availablePromotions })

  return {
    activePromotions,
    availablePromotions,
    totalAfterSavingsPrice,
    mainRebatePrice: getMainInRebatesPrice({ totalAfterSavingsPrice, selectedRebatePromotionsId, activePromotions }),
    promoId: selectedRebatePromotionsId.concat(selectedTirePromotionsId),
    hasSelectedRebatePromotions: Boolean(selectedRebatePromotionsId.length)
  }
}

const withViewModel = withProps(({
  activePromotions,
  availablePromotions
}) => ({
  viewModel: createViewModel({ activePromotions, availablePromotions }),
  initialValues: {
    [PROMOTION_TIRE_FIELD_NAME]: availablePromotions[0].promotionId
  }
}))

export default compose(
  withType({ type: 'BOTPromotionLightbox' }),
  connect(mapStateToProps),
  withViewModel,
  reduxForm({ form: PROMOTION_LIGHT_BOX_FORM })
)(BOTPromotionLightbox)
